import styled from '@emotion/styled';
import {colors, fontSize} from 'patient-ping-remedy/packages/theme';
import {DatePickerWrapper} from '@common/DatePickerWrapper';

export const Wrapper = styled(DatePickerWrapper)`
  input {
    font-size: ${fontSize.standard};
  }

  .disabled input {
    color: ${colors.gray4};
    cursor: not-allowed;

    &::placeholder {
      color: ${colors.gray4};
    }
  }

  .css-fa11kg {
    display: none;
  }
`;
